import {AuthService, DI, SymbolEntity, SymbolsService} from '@core';

import React, {ReactNode, Ref, useRef, useState} from 'react';
import {Dropdown, Form, InputGroup, OverlayTrigger, Popover, Stack} from 'react-bootstrap';
import {Link, useNavigate} from 'react-router-dom';
import './navbar.component.scss';
import {User} from "firebase/auth";

const authService = DI.get(AuthService);
const symbolsService = DI.get(SymbolsService);

const UserPopover = React.forwardRef((props, ref: Ref<HTMLDivElement>) => {
    const navigate = useNavigate();

    const logout = () => {
        authService.logout().then(() => navigate('/'));
    };

    return (
        <Popover ref={ref} id="popover-basic" {...props}>
            <Popover.Body>
                <ul className="sl-user-operations">
                    {/*<li className="sl-user-operations__item">*/}
                    {/*    <i className="sl-user-operations__icon fa-regular fa-user"></i>*/}
                    {/*    Profile*/}
                    {/*</li>*/}
                    <li className="sl-user-operations__item pt-2" onClick={logout}>
                        <i className="sl-user-operations__icon fa-solid fa-power-off"></i>
                        Logout
                    </li>
                </ul>
            </Popover.Body>
        </Popover>
    );
});

const popover = (
    <Popover id="popover-basic">
        <Popover.Body>
            <ul className="sl-user-operations">
                <li className="sl-user-operations__item">
                    <i className="sl-user-operations__icon fa-regular fa-user"></i>
                    Profile
                </li>
                <li className="sl-user-operations__item border-top pt-2">
                    <i className="sl-user-operations__icon fa-solid fa-power-off"></i>
                    Logout
                </li>
            </ul>
        </Popover.Body>
    </Popover>
);

type Props = { searchBar?: boolean };
type States = { symbolList: SymbolEntity[], searchText: string, user: User };

export const NavbarComponent: React.FunctionComponent<Props> = ({searchBar}) => {
    const [states, setStates] = useState({
        symbolList: [],
        searchText: '',
        user: authService.getCurrentUser()
    } as States);
    let $searchInput = useRef(null);

    const searchSymbols = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const searchText = event.target.value;
        const symbolList = searchText.length > 0 ? symbolsService.searchSymbols(event.target.value) : [];
        setStates({...states, searchText, symbolList})
    };

    const clearSearchBox = () => {
        $searchInput.current.value = '';
        setStates({...states, symbolList: []});
    };

    return (
        <Stack direction="horizontal" className="sl-navbar sl-box-shadow justify-content-between px-2">
            {searchBar
                ? <Dropdown className="d-inline mx-2" show={states.symbolList.length > 0} onToggle={clearSearchBox}>
                    <InputGroup>
                        <InputGroup.Text>
                            <i className="bi bi-search"></i>
                        </InputGroup.Text>
                        <Form.Control ref={$searchInput} type="text" placeholder="Search Symbols"
                                      onChange={(event) => searchSymbols(event)}/>
                    </InputGroup>
                    <Dropdown.Menu className="sl-navbar__search-dropdown w-100 overflow-auto">
                        {states.symbolList.map((symbol) => (
                            <Dropdown.Item as={Link} key={symbol.code} to={`/financials/${symbol.code}`}>
                                {symbol.code}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                : <div></div>
            }
            <Stack direction="horizontal">
                <i className="sl-navbar__notification bi bi-bell px-3 "></i>
                <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={<UserPopover/>}>
                    <Stack direction="horizontal" gap={2} className="sl-navbar__user px-3">
                        {/*<img className="sl-navbar__user-avatar" src="/avatar.jpg" />*/}
                        <span className="sl-navbar__username">{states.user.email}</span>
                    </Stack>
                </OverlayTrigger>
            </Stack>
        </Stack>
    );
}
